import { render, staticRenderFns } from "./MatchShareImages.vue?vue&type=template&id=5293b381&scoped=true&"
import script from "./MatchShareImages.vue?vue&type=script&lang=js&"
export * from "./MatchShareImages.vue?vue&type=script&lang=js&"
import style0 from "./MatchShareImages.vue?vue&type=style&index=0&id=5293b381&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293b381",
  null
  
)

export default component.exports